// extracted by mini-css-extract-plugin
module.exports = {"ProductCardTags":"styles_ProductCardTags__bM836","statusTags":"styles_statusTags__wJtyE","sustainabilityTags":"styles_sustainabilityTags__v1kvF","tag":"styles_tag__eX_2l"};